<div class="container" appDnd (fileDropped)="onFileDropped($event)">
    <form [formGroup]="uploadForm" class="form-group">
        <h1 class="form-title">Sensor Data</h1>
        <hr>
        <p>
            Please fill in the following information before uploading your file
        </p>
        <div class="form-group-container">
            <input type="text" placeholder="Title of Document" name="title" formControlName="title"
                class="form-control">

            <input type="text" placeholder="Short Description" name="shortDescription"
                formControlName="shortDescription" class="form-control">
        </div>

        <div class="form-group-container">
            <input type="text" onfocus="(this.type='date')" placeholder="Date Of Data Generation" name="generationDate"
                formControlName="generationDate" class="form-control">

            <input type="text" onfocus="(this.type='date')" placeholder="Date Of Completion" name="completedDate"
                formControlName="completedDate" class="form-control">
        </div>

        <div class="form-group-container">
            <select style="color: #777777;" type="text" placeholder="Country" name="country" formControlName="country"
                class="form-control">
                <option style="color: #777777;" value="" disabled selected>Select Country</option>
                <option style="color: black;" *ngFor="let country of countries" value="{{country.name}}">
                    {{country.name}}</option>
            </select>

            <select style="color: #777777;" type="text" placeholder="Partner" name="partner" formControlName="partner"
                class="form-control">
                <option style="color: #777777;" value="" disabled selected>Select Partner</option>
                <option style="color: black;" *ngFor="let partner of partners" value="{{partner.abbreviation}}">
                    {{partner.abbreviation}}</option>
            </select>
        </div>

        <div class="form-group-container">
            <select style="color: #777777;" type="text" placeholder="Select DiTECT Pilot Related To The Data"
                name="ditectPilot" formControlName="ditectPilot" class="form-control">
                <option style="color: #777777;" value="" disabled selected>Select DiTECT Pilot Related To The Data
                </option>
                <option style="color: black;" *ngFor="let pilot of pilots" value="{{pilot}}">
                    {{pilot}}</option>
            </select>

            <input type="text" placeholder="Laboratory" name="laboratory" formControlName="laboratory"
                class="form-control">
        </div>

        <div class="form-group-container">
            <select style="color: #777777;" type="text" placeholder="Select Device" name="device"
                formControlName="device" class="form-control">
                <option style="color: #777777;" value="" disabled selected>Select Device</option>
                <option style="color: black;" *ngFor="let device of devices" value="{{device}}">
                    {{device}}
                </option>
            </select>

            <mat-form-field appearance="none" style="color: #777777;" class="form-field">
                <mat-label [class.hidden]="uploadForm.value.sensor?.length > 0" style="margin-left: 4px;">Select Sensor</mat-label>
                <mat-select formControlName="sensor" [multiple]="true">
                    <mat-option *ngFor="let sensor of sensors" [value]="sensor">{{sensor}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group-container">
            <input type="text" placeholder="Measurement" name="measurement" formControlName="measurement"
                class="form-control">

            <input type="text" placeholder="Unit of Measurement" name="unit" formControlName="unit"
                class="form-control">
        </div>

        <div class="form-group-container">
            <input type="text" placeholder="Measurement" name="measurement" formControlName="measurement"
                class="form-control">

            <input type="text" placeholder="Unit of Measurement" name="unit"
                formControlName="unit" class="form-control">
        </div>
        
        <div class="form-group-container">
            <select style="color: #777777;" type="text" placeholder="Select Domain" name="domain"
                formControlName="domain" class="form-control">
                <option style="color: #777777;" value="" disabled selected>Select Domain</option>
                <option style="color: black;" *ngFor="let domain of domains" value="{{domain}}">
                    {{domain}}
                </option>
            </select>
        </div>

        <button class="submit-btn" mat-raised-button type="submit" (click)="submitForm()">Submit</button>
    </form>

    <div class="files-container">
        <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)">
        <img src="assets/img/ic-upload-file.svg" style="height: 10vh">
        <h3>Drag and drop file here</h3>
        <h3>or</h3>
        <label for="fileDropRef">Browse for file</label>
        <div class="files-list">
            <div class="single-file" *ngFor="let file of files; let i = index">
                <img src="assets/img/ic-file.svg" width="45px" alt="file">
                <div class="info">
                    <h4 class="name">
                        {{ file.name }}
                    </h4>
                </div>
                <img src="assets/img/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">
            </div>
        </div>
    </div>

    <swal>
    </swal>

</div>